export default "__VITE_ASSET__DreUTA9M__"